module.exports = __webpack_public_path__ + "static/media/sheer-allure.384807af.png";